export default {
  navbar: {
    home: '홈',
    jobs: '채용',
    companies: '기업',
    about: '회사소개',
    customerService: '고객서비스',
    signIn: '로그인',
    register: '회원가입'
  },
  customerService: {
    title: '고객 서비스 문의',
    subtitle: '전문 지원 팀이 24시간 언제나 당신의 질문에 답변해드립니다.',
    onlineService: '온라인 서비스',
    serviceDescription: '전문 지원 팀이 24시간 언제나 지원해드립니다.',
    startChat: '온라인 채팅 시작',
    responseTime: '평균 답변 시간: 30초',
    instantResponse: '즉각적인 응답',
    instantResponseDesc: '고객 서비스 팀이 24시간 온라인으로 대기하며 평균 응답 시간은 2분 미만입니다',
    professionalTeam: '전문 팀',
    professionalTeamDesc: '엄격한 교육을 받은 고객 서비스 직원으로 모든 비즈니스 프로세스에 익숙합니다',
    securityPrivacy: '보안 및 개인정보 보호',
    securityPrivacyDesc: '모든 정보는 암호화되어 절대적인 보안을 보장합니다',
    serviceOnline: '서비스 온라인',
    seniorConsultant: '수석 고객 컨설턴트'
  },
  home: {
    heroTitle: '영화 산업에서 당신의 꿈의 직업을 찾아보세요',
    heroSubtitle: '최고의 영화관과 엔터테인먼트 기업과 연결하세요. 오늘 흥미로운 영화 세계에서 여정을 시작하세요.',
    popularCategories: '인기 직업 카테고리',
    categoriesDescription: '다양한 영화와 엔터테인먼트 분야의 기회 탐색',
    featuredJobOpportunities: '추천 직업 기회',
    discoverLatestOpenings: '최고의 영화관에서 최신 채용 정보 확인',
    openPositions: '개의 채용 중',
    quickApply: '빠른 지원',
    whyChooseUs: '왜 우리를 선택해야 하나요',
    joinLargestNetwork: '가장 큰 영화 전문가 네트워크에 가입하세요',
    categories: {
      theaterOperations: {
        title: '영화관 운영',
        description: '영화관의 일상 운영을 관리하고 원활한 상영을 보장합니다'
      },
      boxOfficeManagement: {
        title: '매표소 관리',
        description: '매표소에서 티켓 판매 및 고객 서비스 처리'
      },
      cinemaTechnology: {
        title: '영화관 기술',
        description: '고급 영화관 장비 및 시스템 유지 및 운영'
      },
      customerService: {
        title: '고객 서비스',
        description: '영화관 관객에게 탁월한 서비스 제공'
      },
      foodBeverage: {
        title: '음식 및 음료',
        description: '스낵 코너 및 음식 서비스 운영 관리'
      },
      marketingPromotions: {
        title: '마케팅 및 프로모션',
        description: '영화관을 위한 마케팅 전략 수립 및 실행'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: '영화관 관리자',
        company: 'AMC 영화관',
        location: '뉴욕, NY',
        type: '정규직',
        salary: '$65K - $85K',
        benefit: '복리후생'
      },
      digitalProjectionist: {
        title: '디지털 상영사',
        company: 'Regal 영화관',
        location: '로스앤젤레스, CA',
        type: '정규직',
        salary: '$45K - $60K',
        benefit: '교육'
      },
      marketingCoordinator: {
        title: '마케팅 코디네이터',
        company: 'Cinemark',
        location: '시카고, IL',
        type: '정규직',
        salary: '$50K - $65K',
        benefit: '원격'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: '대규모 산업 네트워크',
        description: '전 세계 2,500개 이상의 영화관과 엔터테인먼트 기업과 연결',
        stat: '15,000명 이상의 활성 사용자'
      },
      verifiedEmployers: {
        title: '검증된 고용주',
        description: '모든 고용주는 엄격하게 검토되어 실제 기회를 보장합니다',
        stat: '100% 인증 기업'
      },
      careerGrowth: {
        title: '커리어 성장',
        description: '교육 자료 및 승진 기회 접근',
        stat: '89% 성공률'
      }
    }
  },
  jobs: {
    heroTitle: '우리 영화 가족에 합류하세요',
    heroSubtitle: '이야기를 살아있게 만드는 마법의 일부가 되세요. 성장하는 우리 팀에 합류할 열정적인 사람을 찾고 있습니다.',
    viewPositions: '채용 정보 보기',
    currentOpenings: '현재 채용 중',
    department: '부서',
    location: '위치',
    applyNow: '지금 지원',
    whyJoinUs: '왜 함께해야 하나요',
    ourCulture: '우리 문화',
    applicationProcess: '지원 과정',
    startYourJourney: '당신의 여정을 시작하세요',
    benefits: {
      freeMovieAccess: {
        title: '무료 영화',
        description: '당신과 가족을 위한 무제한 무료 영화를 즐기세요.'
      },
      careerGrowth: {
        title: '커리어 개발',
        description: '종합적인 교육과 명확한 승진 경로.'
      },
      flexibleSchedule: {
        title: '유연한 근무 시간',
        description: '일과 생활의 균형을 위한 유연한 스케줄 옵션.'
      }
    },
    jobList: [
      {
        title: '영화관 운영 관리자',
        location: '뉴욕, NY',
        type: '정규직',
        description: '플래그십 위치에서 일상적인 영화관 운영을 주도하고 탁월한 고객 서비스를 보장합니다.'
      },
      {
        title: '시니어 상영사',
        location: '로스앤젤레스, CA',
        type: '정규직',
        description: '최적의 관람 경험을 위해 디지털 상영 시스템을 운영하고 유지 관리합니다.'
      },
      {
        title: '스낵 팀장',
        location: '시카고, IL',
        type: '정규직',
        description: '스낵 코너 운영을 관리하고 전문 음식 서비스 팀을 이끌어갑니다.'
      },
      {
        title: '고객 경험 전문가',
        location: '마이애미, FL',
        type: '시간제',
        description: '탁월한 서비스를 제공하고 고객에게 잊지 못할 경험을 만들어 줍니다.'
      },
      {
        title: '기술 지원 전문가',
        location: '시애틀, WA',
        type: '정규직',
        description: '영화관 장비 및 시스템을 유지하고 문제를 해결합니다.'
      },
      {
        title: '이벤트 코디네이터',
        location: '보스턴, MA',
        type: '정규직',
        description: '특별 상영 및 개인 영화관 이벤트를 계획하고 실행합니다.'
      }
    ],
    testimonials: [
      {
        name: '에밀리 리차드슨',
        position: '영화관 관리자',
        quote: '여기서 일하는 것은 믿을 수 없는 여정이었습니다. 성장 기회와 지원 환경이 이곳을 그냥 직업 이상으로 만듭니다.'
      },
      {
        name: '마이클 앤더슨',
        position: '시니어 상영사',
        quote: '우리가 함께 일하는 기술과 장비는 최고 수준입니다. 어떤 영화 애호가에게나 이것은 꿈이 현실로 이뤄진 것입니다.'
      },
      {
        name: '사라 마르티네즈',
        position: '이벤트 코디네이터',
        quote: '여기 팀워크는 놀랍습니다. 우리는 함께 고객에게 잊지 못할 경험을 만듭니다.'
      }
    ],
    applicationSteps: [
      {
        title: '온라인 지원',
        description: '우리 채용 포털을 통해 신청서를 제출하세요.'
      },
      {
        title: '초기 검토',
        description: '우리 팀이 48시간 내에 신청서를 검토할 것입니다.'
      },
      {
        title: '인터뷰',
        description: '기회에 대해 논의하기 위해 우리 팀과 만나세요.'
      },
      {
        title: '환영합니다',
        description: '우리 영화 가족과 함께 여정을 시작하세요.'
      }
    ]
  },
  companies: {
    searchPlaceholder: '기업 검색...',
    location: '위치',
    companySize: '기업 규모',
    industry: '산업',
    openPositions: '개의 채용 중',
    viewJobs: '채용 보기',
    loadMore: '더 많은 기업 로드',
    companyList: [
      {
        name: '유니버설 엔터테인먼트 그룹',
        location: '로스앤젤레스, CA',
        size: '5,000명 이상의 직원',
        description: '전 세계적으로 영화 및 TV 콘텐츠를 제작하고 유통하는 선도적인 글로벌 엔터테인먼트 기업입니다.'
      },
      {
        name: '시네마크 프로덕션',
        location: '뉴욕, NY',
        size: '2,000-5,000명의 직원',
        description: '대작 영화와 혁신적인 디지털 콘텐츠를 전문으로 하는 수상 경력이 있는 프로덕션 스튜디오입니다.'
      },
      {
        name: '디지털 시네마 솔루션',
        location: '샌프란시스코, CA',
        size: '1,000-2,000명의 직원',
        description: '혁신적인 솔루션을 통해 디지털 영화 경험을 혁신하는 기술 기반 기업입니다.'
      },
      {
        name: '파라마운트 디지털 스튜디오',
        location: '시카고, IL',
        size: '500-1,000명의 직원',
        description: '최첨단 기술을 통해 차세대 디지털 엔터테인먼트 경험을 만듭니다.'
      },
      {
        name: '글로벌 시어터 네트워크',
        location: '마이애미, FL',
        size: '1,000-2,000명의 직원',
        description: '대도시에 최첨단 시설을 갖춘 프리미엄 영화관 체인을 운영합니다.'
      },
      {
        name: '실버스크린 테크놀러지',
        location: '시애틀, WA',
        size: '500-1,000명의 직원',
        description: '현대 영화 산업을 위한 최첨단 소프트웨어 솔루션을 개발합니다.'
      }
    ]
  },
  about: {
    heroTitle: '회사 소개',
    heroSubtitle: '창의성과 기술이 만나는 곳에서, 혁신적인 렌즈를 통해 이야기가 살아있게 됩니다.',
    ourStory: '우리의 이야기',
    storyParagraph1: '시네마스터 스튜디오는 2010년에 설립되었으며, 지난 10년 이상 영화 혁신의 선두에 서 있습니다. 우리의 여정은 단순하지만 강력한 비전으로 시작되었습니다: 전 세계 관객과 공감하는 매력적인 시각적 이야기를 만드는 것입니다.',
    storyParagraph2: '오늘, 우리는 글로벌 브랜드 및 업계의 재능있는 아티스트와 협력하는 선도적인 프로덕션 스튜디오 중 하나로 자랑스럽게 생각합니다. 탁월함에 대한 우리의 약속과 이야기를 전하는 열정은 우리를 계속 전진시킵니다.',
    ourCoreValues: '우리의 핵심 가치',
    creativeExcellence: '창의적 탁월성',
    creativeExcellenceDesc: '한계를 넓히고 시각적 내러티브에서 새로운 표준을 설정합니다.',
    collaborativeSpirit: '협력 정신',
    collaborativeSpiritDesc: '함께 노력하여 독특한 비전을 현실로 만듭니다.',
    qualityFirst: '품질 우선',
    qualityFirstDesc: '우리가 만드는 모든 프레임에서 탁월함을 추구합니다.',
    meetOurTeam: '우리 팀을 만나세요',
    creativeDirector: '크리에이티브 디렉터',
    leadCinematographer: '수석 영화감독',
    technicalDirector: '기술 디렉터',
    productionManager: '프로덕션 매니저',
    yearsExperience: '년의 경험',
    projectsCompleted: '완료된 프로젝트',
    industryAwards: '업계 상',
    happyClients: '행복한 고객'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. 모든 권리 보유.',
    description: '영화 산업에서 재능과 기회를 연결합니다. 영화관 운영, 관리 또는 기술 직무에서 당신의 다음 역할을 찾으세요.',
    quickLinks: '빠른 링크',
    jobSeeker: '구직자',
    newsletter: '뉴스레터',
    newsletterText: '최신 채용 업데이트와 커리어 조언을 받으려면 구독하세요.',
    emailPlaceholder: '이메일 주소',
    subscribe: '구독하기',
    quickLinksList: ['회사 소개', '문의하기', '개인정보 보호정책', '서비스 이용약관'],
    jobSeekerLinksList: ['채용 탐색', '커리어 리소스', '이력서 조언', '채용 알림']
  }
}